import { getUIpreferences } from "../../../app/api/getUIPreferences";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse } from "../../../Orchestrator/Types/Index";
import { IUIPreferences } from "../../../Orchestrator/Types/Interface/IUIPreferences";

class GetUIPreferencesAction extends BaseAction<IUIPreferences, void> {

    // Overriding `run` and returning the UI Preferences
    override async run(): Promise<IUIPreferences | null> {
        let uiPreferences: IUIPreferences | null = null;
        try {
            //This condition is added to avoid multiple API calls for the same data
            if (this.result === null) {
                const response: IApiResponse<IUIPreferences> = await getUIpreferences();
                if (response.status === "ok" && response.answer) {
                    const uiPreference = response.answer;
                    if (!uiPreferences) {
                        uiPreferences = uiPreference;
                        updateRecoilState("calendarDayIntervalAtom", uiPreference.calendarDayInterval)
                    } else {
                        console.warn("Not available.");
                    }
                } else {
                    console.warn("Failed to data.");
                }
            }
        } catch (error: any) {
            console.error("Error fetching data:", error);
        } finally {
            return uiPreferences;
        }
    }
}

export const uiPreferencesAction = new GetUIPreferencesAction()


